import axios, { AxiosPromise } from 'axios';

import { ISize } from '../../../@types/model/masterData/size/size';
import { ISizeUpsert } from '../../../@types/model/masterData/size/sizeUpsert';

export default class SizeHttpService {
    public static getSizeData() : AxiosPromise<Array<ISize>> {
        return axios.get(`${API_URL}/v1/Size/GetAllWeb`);
    }

    public static addOrUpdateSize(upsert : ISizeUpsert) : AxiosPromise<ISize> {
        return axios.post(`${API_URL}/v1/Size/PostSize`, upsert);
    }

    public static deleteSize(sizeId : number) : AxiosPromise<ISize> {
        return axios.delete(`${API_URL}/v1/Size/Delete`, {
            params : { sizeId },
        });
    }
}
